import styles from '../styles.module.scss';
import skeleton from './styles.module.scss';
import { FormGroup } from '@starsoft/common/components/FormGroup';
import { Input } from '@starsoft/common/components/Input';
import TransactionResultDetails from '@starsoft/common/components/Transactions/Result/Details';

export function TransactionsCommonMappingModalContentDetailsHeaderSkeleton() {
  return (
    <div className={styles.container}>
      <div className={styles.container__row}>
        <h1 className={styles.container__title}>
          <div className={skeleton.title} />
        </h1>
        <div className={skeleton.button} />
      </div>
      <FormGroup isLoading loading={{ label: true, secondary: true }}>
        <Input isLoading />
      </FormGroup>
      <div
        className={`${styles.container__row} ${styles['container__row--wrapped']}`}
      >
        <div className={skeleton.label} />
        <div className={skeleton.label} />
      </div>
      <TransactionResultDetails minimal isLoading />
    </div>
  );
}
